var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhotoHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "31px",
    viewBox: "0 0 38 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPhotoHeader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final-Home-with-submenu",
    transform: "translate(-1416.000000, -111.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(1079.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top",
    transform: "translate(16.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(230.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(71.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Photos",
    transform: "translate(20.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.27958,17.8859912 C11.27958,22.1643203 14.735421,25.6342026 18.9964373,25.6342026 C23.2574536,25.6342026 26.72042,22.1643203 26.72042,17.8859912 C26.72042,13.6076621 23.264579,10.1377798 19.0035627,10.1377798 C14.7425464,10.1377798 11.27958,13.6076621 11.27958,17.8859912 Z M35.6272267,4.77198246 L27.311832,4.77198246 C26.72042,2.38241403 26.1290081,0 23.7491093,0 L14.2508907,0 C11.8781174,0 11.27958,2.38241403 10.688168,4.77198246 L2.3727733,4.77198246 C1.0688168,4.77198246 0,5.84514193 0,7.15439649 L0,28.617586 C0,29.9268405 1.0688168,31 2.3727733,31 L35.6272267,31 C36.9311832,31 38,29.9268405 38,28.617586 L38,7.15439649 C38,5.84514193 36.9311832,4.77198246 35.6272267,4.77198246 Z M19.0035627,28.4673436 C13.1820739,28.4673436 8.46502906,23.7311332 8.46502906,17.8859912 C8.46502906,12.0408493 13.1820739,7.30463882 19.0035627,7.30463882 C24.8250516,7.30463882 29.5420964,12.0408493 29.5420964,17.8859912 C29.5420964,23.7311332 24.8250516,28.4673436 19.0035627,28.4673436 Z M35.6272267,11.98231 L30.8745547,11.98231 L30.8745547,9.54396492 L35.6272267,9.54396492 L35.6272267,11.98231 Z",
    id: "icPhotoHeader"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhotoHeader);
export default __webpack_public_path__ + "static/media/icPhotoHeader.9838f42b72f19e269ea34d2408fbe642.svg";
export { ForwardRef as ReactComponent };